<template>
  <div
    :style="{ backgroundImage: url ? 'url(' + url + ')' : 'none' }"
    class="single-picture-upload"
  >
    <el-upload
      ref="upload"
      v-if="!readonly"
      :action="action"
      :headers="headers"
      :data="data"
      :show-file-list="false"
      accept=".jpg,.jpeg,.png,.gif,.svg"
      :before-upload="onBeforeUpload"
      :on-progress="onProgress"
      :on-success="onSuccess"
    >
      <span class="el-upload" v-if="!value && progress == -1"
        ><i class="el-icon-upload"></i
      ></span>
    </el-upload>
    <el-progress
      v-if="progress >= 0"
      type="circle"
      :percentage="parseInt(progress)"
      class="progress"
    ></el-progress>
    <div v-if="value || progress >= 0" class="actions">
      <span v-if="!readonly" @click="onBrowse"
        ><i class="el-icon-upload"></i
      ></span>
      <span v-if="value" @click="onView"><i class="el-icon-view"></i></span>
      <span v-if="!readonly" @click="onDelete"
        ><i class="el-icon-delete"></i
      ></span>
    </div>
    <div v-if="title" class="title">{{ title }}</div>
    <el-dialog :visible.sync="viewVisible">
      <img style="max-width: 100%" :src="value | remoteAsset" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import emitter from 'element-ui/src/mixins/emitter';
import filter from '@/filter';

const {
  all: { remoteAsset },
} = filter;

const beautifySize = size => {
  if (size >= 1000000) {
    return `${size / 1000}GB`;
  } else if (size >= 1000) {
    return `${size / 1000}MB`;
  }
  return `${size}KB`;
};

export default {
  name: 'SinglePictureUpload',
  mixins: [emitter],
  inject: {
    elForm: {
      default: '',
    },
    elFormItem: {
      default: '',
    },
  },
  data() {
    return {
      progress: -1,
      fileList: [],
      viewVisible: false,
    };
  },
  props: {
    readonly: {
      type: Boolean,
      default: false,
    },
    action: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      value: '',
    },
    value: String,
    headers: {},
    data: {},
    maxSize: {
      type: Number,
      default: 5000,
    },
  },
  computed: {
    validateState() {
      return this.elFormItem ? this.elFormItem.validateState : '';
    },
    needStatusIcon() {
      return this.elForm ? this.elForm.statusIcon : false;
    },
    validateIcon() {
      return {
        validating: 'el-icon-loading',
        success: 'el-icon-circle-check',
        error: 'el-icon-circle-close',
      }[this.validateState];
    },
    url() {
      return remoteAsset(this.value);
    },
  },
  methods: {
    updateValue(value) {
      this.$emit('input', value);
      this.$emit('change', value);
      this.dispatch('ElFormItem', 'el.form.change', [value]);
    },
    onBeforeUpload(file) {
      const isLTMaxSize = file.size / 1024 < this.maxSize;
      if (!isLTMaxSize) {
        this.$message.error(
          this.$t('err_file_size_should_be_lt', [beautifySize(this.maxSize)]),
        );
        return false;
      }

      for (let i = 0; i < this.fileList.length; i++) {
        this.$refs.upload.abort(this.fileList[i]);
      }

      this.updateValue('');
      this.progress = 0;
      this.fileList.splice(0, this.fileList.length, file);
      return true;
    },
    onSuccess(res, file) {
      this.progress = -1;
      this.updateValue(res[file.name]);
    },
    onProgress(event) {
      this.progress = event.percent;
    },
    onBrowse() {
      if (!this.$refs.upload.disabled) {
        this.$refs.upload.$refs['upload-inner'].$refs.input.click();
      }
    },
    onView() {
      this.viewVisible = true;
    },
    onDelete() {
      for (let i = 0; i < this.fileList.length; i++) {
        this.$refs.upload.abort(this.fileList[i]);
      }

      this.updateValue('');
      this.progress = -1;
    },
  },
};
</script>
